@for(item of allItems; track item; let i = $index){<div id="{{ 'cbx' + item.key }}">
    <ds-checkbox
        [checkboxInput]="checkboxConfigs[item.key]"
        (change)="onClick($event, item)">
    </ds-checkbox>
</div>}